export const teamMembers = [
  {
    id: 'amara-okafor',
    name: 'Amara Okafor',
    role: 'Principal Consultant',
    specialisation: 'Talent Acquisition',
    bio: 'Amara leads senior and specialist searches, pairing rigorous assessment with a genuine curiosity about what makes people stay and thrive.',
    expertise: ['Senior hiring', 'Candidate assessment', 'Scale-up teams'],
    image:
      'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_team-amara.webp',
  },
  {
    id: 'daniel-hartley',
    name: 'Daniel Hartley',
    role: 'Senior HR Advisor',
    specialisation: 'HR Advisory',
    bio: 'Daniel has spent two decades helping leadership teams through restructures, growth phases and difficult people decisions — calmly and candidly.',
    expertise: ['HR strategy', 'Leadership support', 'Organisational change'],
    image:
      'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_team-daniel.webp',
  },
  {
    id: 'sofia-lindqvist',
    name: 'Sofia Lindqvist',
    role: 'Lead Consultant',
    specialisation: 'People & Organisation',
    bio: 'Sofia works with growing businesses on culture, team design and leadership development, turning good intentions into lasting habits.',
    expertise: ['Team development', 'Workplace culture', 'Leadership programmes'],
    image:
      'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_team-sofia.webp',
  },
  {
    id: 'marcus-chen',
    name: 'Marcus Chen',
    role: 'Search Consultant',
    specialisation: 'Specialist Recruitment',
    bio: 'Marcus focuses on technology and product hiring, building long-term relationships with candidates well before roles open.',
    expertise: ['Technology hiring', 'Talent mapping'],
    image:
      'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_team-marcus.webp',
  },
  {
    id: 'helen-whitaker',
    name: 'Helen Whitaker',
    role: 'Associate Director',
    specialisation: 'Leadership Development',
    bio: 'Helen coaches executives and new leaders through transitions, drawing on a long career in operational leadership.',
    expertise: ['Executive coaching', 'Leadership transitions'],
    image:
      'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_team-helen.webp',
  },
  {
    id: 'priya-raman',
    name: 'Priya Raman',
    role: 'Career Advisor',
    specialisation: 'Career Guidance',
    bio: 'Priya supports professionals exploring their next step, helping them articulate their strengths and find the right environment.',
    expertise: ['Career transitions', 'Professional profiles'],
    image:
      'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_team-priya.webp',
  },
];

export const services = [
  {
    number: '01',
    title: 'Talent Acquisition',
    summary: 'Finding exceptional professionals who bring capability, character, and lasting value.',
    headline: 'Find people who move businesses forward.',
    body: 'We approach every search as a long-term match, not a transaction. By understanding your business, your team and the moment you are in, we find people whose capability and character will hold up well beyond their first year.',
    points: ['Senior & leadership hiring', 'Specialist recruitment', 'Candidate assessment', 'Long-term matching'],
    image:
      'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_service-talent.webp',
  },
  {
    number: '02',
    title: 'HR Advisory',
    summary: 'Helping leadership teams navigate complex people decisions with clarity.',
    headline: 'Clarity for complex people decisions.',
    body: 'From building an HR function for the first time to steering a business through change, we sit alongside leadership as a practical, candid advisor — helping you decide well and act with confidence.',
    points: ['HR planning & structure', 'Leadership support', 'People practices & policy', 'Organisational change'],
    image:
      'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_service-hr.webp',
  },
  {
    number: '03',
    title: 'People & Organisation',
    summary: 'Building stronger teams, healthier cultures, and resilient organisations.',
    headline: 'Build an organisation where people thrive.',
    body: 'Culture is shaped by everyday decisions. We help you design teams, develop leaders and build the habits that let people do their best work — so the organisation grows stronger as it grows larger.',
    points: ['Team development', 'Workplace culture', 'Leadership development', 'Organisational growth'],
    image:
      'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_service-org.webp',
  },
];